import { apiSlice } from "./apiSlice";
import { QUIZ_IMAGES_URL } from "../constants";

export const quizImageApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // =====================================================
    // Get Quiz Image Status
    // GET /api/quiz-images/:quizId/status
    // =====================================================
    getQuizImageStatus: builder.query({
      query: (quizId) => ({
        url: `${QUIZ_IMAGES_URL}/${quizId}/status`,
      }),

      providesTags: ["QuizImage"],

      keepUnusedDataFor: 5,
    }),

    // =====================================================
    // Update Quiz Image Status
    // PUT /api/quiz-images/:quizId/status
    // =====================================================
    updateQuizImageStatus: builder.mutation({
      query: (quizId) => ({
        url: `${QUIZ_IMAGES_URL}/${quizId}/status`,
        method: "PUT",
      }),

      invalidatesTags: ["QuizImage"],
    }),
  }),
});

export const {
  useGetQuizImageStatusQuery,
  useUpdateQuizImageStatusMutation,
} = quizImageApiSlice;